import _curry from 'lodash/curry';
import _reduce from 'lodash/reduce';
import _isFunction from 'lodash/isFunction';

var addActionIfEnabled = _curry(function (params, acc, action) {
  var isEnabled = action.isEnabled;

  if (!isEnabled || !_isFunction(isEnabled)) {
    acc.push(action);
    return acc;
  }

  var enabled = isEnabled(params);

  if (enabled) {
    acc.push(action);
  }

  return acc;
});

var getEnabledActions = function getEnabledActions(actions, params) {
  return _reduce(actions, addActionIfEnabled(params), []);
};

export default getEnabledActions;